var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _DiabetowiseDischargeCompletedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";

//---- Automatically generated, don't update this part ----
let DiabetowiseDischargeCompletedJournalEvent = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("number"), _dec4 = attr("string"), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = attr("boolean", {
  allowNull: true
}), _dec7 = attr("number"), _dec8 = attr("number"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("number"), _dec12 = attr("boolean", {
  allowNull: true
}), _dec13 = attr("boolean", {
  allowNull: true
}), _dec14 = attr("boolean", {
  allowNull: true
}), _dec15 = attr("boolean", {
  allowNull: true
}), _dec16 = attr("boolean", {
  allowNull: true
}), _dec17 = attr("string"), _dec18 = attr("string"), _dec19 = attr("string"), _dec20 = attr("string"), _dec21 = attr("string"), _dec22 = attr("string"), _dec23 = attr("string"), _dec24 = attr("number"), _dec25 = attr("string"), _dec26 = attr("string"), _dec27 = attr("number"), _dec28 = attr("string"), _dec29 = attr("number"), _dec30 = attr("string"), _dec31 = attr("string"), _dec32 = attr("number"), _dec33 = attr("number"), _dec34 = attr("number"), _dec35 = belongsTo("patient", {
  async: false,
  inverse: "diabetowiseDischargeCompletedJournalEvent"
}), _class = (_DiabetowiseDischargeCompletedJournalEvent = class DiabetowiseDischargeCompletedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * The last name of the patient
     */
    _initializerDefineProperty(this, "lastName", _descriptor, this);
    /**
     * The first name of the patient
     */
    _initializerDefineProperty(this, "firstName", _descriptor2, this);
    /**
     * L'âge du patient
     */
    _initializerDefineProperty(this, "age", _descriptor3, this);
    /**
     * Le sexe du patient
     */
    _initializerDefineProperty(this, "gender", _descriptor4, this);
    /**
     * has progressive or life-threatening disease in the short term
     */
    _initializerDefineProperty(this, "prognosticLifeThreatening", _descriptor5, this);
    /**
     * the patient is a smoker
     */
    _initializerDefineProperty(this, "smoker", _descriptor6, this);
    /**
     * Patient's weight in kg
     */
    _initializerDefineProperty(this, "weight", _descriptor7, this);
    /**
     * Patient's height in cm
     */
    _initializerDefineProperty(this, "height", _descriptor8, this);
    /**
     * the patient do sport
     */
    _initializerDefineProperty(this, "doSport", _descriptor9, this);
    /**
     * Phone number of the patient
     */
    _initializerDefineProperty(this, "phone", _descriptor10, this);
    /**
     * the hba1c in percent
     */
    _initializerDefineProperty(this, "hba1c", _descriptor11, this);
    /**
     * take metformine
     */
    _initializerDefineProperty(this, "met", _descriptor12, this);
    /**
     * take isglt2
     */
    _initializerDefineProperty(this, "isglt2", _descriptor13, this);
    /**
     * take AR GLP-1
     */
    _initializerDefineProperty(this, "arglp1", _descriptor14, this);
    /**
     * take insulin
     */
    _initializerDefineProperty(this, "insulin", _descriptor15, this);
    /**
     * take idpp4
     */
    _initializerDefineProperty(this, "idpp4", _descriptor16, this);
    /**
     * has had hypoglycaemia in the past year
     */
    _initializerDefineProperty(this, "hypoglycaemia", _descriptor17, this);
    /**
     * has had severe hypoglycaemia in the past year
     */
    _initializerDefineProperty(this, "severeHypoglycaemia", _descriptor18, this);
    /**
     * has had hyperglycaemia in the past year
     */
    _initializerDefineProperty(this, "hyperglycaemia", _descriptor19, this);
    /**
     * has had severe hyperglycaemia in the past year
     */
    _initializerDefineProperty(this, "severeHyperglycaemia", _descriptor20, this);
    /**
     * Hospitalisation for heart failure, acute renal failure/dialysis, atheromatous cardiovascular disease in the past year
     */
    _initializerDefineProperty(this, "hospitalisation", _descriptor21, this);
    _initializerDefineProperty(this, "neuropathie", _descriptor22, this);
    _initializerDefineProperty(this, "chronicRenalFailure", _descriptor23, this);
    /**
     * DFG formule CKD-EPI (en mL/min/1.73m^2)
     */
    _initializerDefineProperty(this, "dfg", _descriptor24, this);
    /**
     * albuminuria in the past year
     */
    _initializerDefineProperty(this, "albuminuria", _descriptor25, this);
    /**
     * Maladie cardiovasculaire athéromateurs
     */
    _initializerDefineProperty(this, "mcva", _descriptor26, this);
    /**
     * RAC in mg/g
     */
    _initializerDefineProperty(this, "rac", _descriptor27, this);
    /**
     * heart failure in the past yea
     */
    _initializerDefineProperty(this, "heartFailure", _descriptor28, this);
    /**
     * FEVG in %
     */
    _initializerDefineProperty(this, "fevg", _descriptor29, this);
    /**
     * other severes comorbidity in the past year
     */
    _initializerDefineProperty(this, "severeComorbidity", _descriptor30, this);
    /**
     * hta in the past year
     */
    _initializerDefineProperty(this, "hta", _descriptor31, this);
    /**
     * last systolic in consultation
     */
    _initializerDefineProperty(this, "systolic", _descriptor32, this);
    /**
     * last diastolic in consultation
     */
    _initializerDefineProperty(this, "diastolic", _descriptor33, this);
    /**
     * dyslipidemia in the past year
     */
    _initializerDefineProperty(this, "dyslipidemia", _descriptor34, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor35, this);
  }
  static validations(intl) {
    return {
      lastName: validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.last-name")
      }),
      firstName: validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.first-name")
      }),
      age: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.age")
      }), validateNumber({
        integer: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.age")
      })],
      gender: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.gender")
      }), validateInclusion({
        list: ["male", "female"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.gender")
      })],
      weight: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.weight")
      }), validateNumber({
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.weight")
      })],
      height: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.height")
      }), validateNumber({
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.height")
      })],
      doSport: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.do-sport")
      }), validateInclusion({
        list: ["yes", "no", "stopped"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.do-sport")
      })],
      phone: validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.phone")
      }),
      hba1c: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hba1c")
      }), validateNumber({
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hba1c")
      })],
      hypoglycaemia: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hypoglycaemia")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hypoglycaemia")
      })],
      hyperglycaemia: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hyperglycaemia")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hyperglycaemia")
      })],
      hospitalisation: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hospitalisation")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hospitalisation")
      })],
      neuropathie: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.neuropathie")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.neuropathie")
      })],
      chronicRenalFailure: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.chronic-renal-failure")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.chronic-renal-failure")
      })],
      albuminuria: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.albuminuria")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.albuminuria")
      })],
      mcva: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.mcva")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.mcva")
      })],
      heartFailure: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.heart-failure")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.heart-failure")
      })],
      severeComorbidity: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.severe-comorbidity")
      }), validateInclusion({
        list: ["yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.severe-comorbidity")
      })],
      hta: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hta")
      }), validateInclusion({
        list: ["treated", "yes", "no", "unknown"],
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.hta")
      })],
      dyslipidemia: [validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.dyslipidemia")
      }), validateNumber({
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.dyslipidemia")
      })],
      prognosticLifeThreatening: validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.prognostic-life-threatening")
      }),
      smoker: validatePresence({
        presence: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.smoker")
      }),
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.diabetowise-discharge-completed-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      dfg: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.dfg")
      }),
      rac: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.rac")
      }),
      fevg: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.fevg")
      }),
      systolic: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.systolic")
      }),
      diastolic: validateNumber({
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.diastolic")
      }),
      severeHypoglycaemia: validateInclusion({
        list: ["yes", "no", "unknown"],
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.severe-hypoglycaemia")
      }),
      severeHyperglycaemia: validateInclusion({
        list: ["yes", "no", "unknown"],
        allowBlank: true,
        description: intl.t("validations.diabetowise-discharge-completed-journal-event.severe-hyperglycaemia")
      })
    };
  }
}, _defineProperty(_DiabetowiseDischargeCompletedJournalEvent, "type", "diabetowise-discharge-completed-journal-event"), _DiabetowiseDischargeCompletedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "lastName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "firstName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "age", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "gender", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "prognosticLifeThreatening", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "smoker", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "weight", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "height", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "doSport", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hba1c", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "met", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isglt2", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "arglp1", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "insulin", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "idpp4", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "hypoglycaemia", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "severeHypoglycaemia", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "hyperglycaemia", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "severeHyperglycaemia", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "hospitalisation", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "neuropathie", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "chronicRenalFailure", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "dfg", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "albuminuria", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "mcva", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "rac", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "heartFailure", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "fevg", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "severeComorbidity", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "hta", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "systolic", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "diastolic", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "dyslipidemia", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DiabetowiseDischargeCompletedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.